import { Link } from "react-router-dom";
import { ArrowRight, Award, MapPin, Zap } from "lucide-react";

const IMG =
    "https://images.unsplash.com/photo-1750492960742-0560531252d0?fm=jpg&q=70&w=1200&auto=format&fit=crop";

export default function AboutSection() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A] border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <div className="lg:col-span-5 relative">
                    <div className="relative aspect-[4/5] overflow-hidden">
                        <img
                            src={IMG}
                            alt="Car covered in soap suds during a hand wash"
                            className="w-full h-full object-cover"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
                    </div>
                    <div className="hidden md:block absolute -bottom-6 -right-6 bg-[#9D4CDD] px-6 py-5 max-w-[240px]">
                        <div className="font-heading text-3xl font-black text-white leading-none">
                            4+ Years
                        </div>
                        <div className="mt-2 font-heading text-[10px] uppercase tracking-[0.24em] text-white/90">
                            Detailing Excellence
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-7">
                    <div className="font-heading text-xs uppercase tracking-[0.32em] text-[#9D4CDD] font-bold mb-4">
                        / Who We Are
                    </div>
                    <h2 className="font-heading text-4xl md:text-5xl font-black uppercase tracking-tighter text-white">
                        Built on grit,{" "}
                        <span className="text-[#9D4CDD]">obsessed with detail.</span>
                    </h2>
                    <blockquote className="mt-8 pl-5 border-l-2 border-[#9D4CDD] text-lg text-white/80 italic leading-relaxed">
                        &ldquo;Every vehicle that leaves our care is a reflection
                        of who we are. Clean Done Right, Service Done Kindly.&rdquo;
                    </blockquote>
                    <p className="mt-6 text-white/65 leading-relaxed">
                        AC Detailing is a family-operated mobile detail service
                        rooted in Surprise, Arizona. We started with a pressure
                        washer, a pickup, and a promise: treat every car like it
                        was our own. Today we serve the entire West Valley with
                        the same standard.
                    </p>

                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
                        {[
                            {
                                icon: Zap,
                                title: "Fast & Friendly Service",
                                body: "Quick turnarounds, on-time arrivals, and a crew that treats you right.",
                            },
                            {
                                icon: MapPin,
                                title: "We Come to You",
                                body: "Mobile service across Surprise & the West Valley.",
                            },
                            {
                                icon: Award,
                                title: "Results Guaranteed",
                                body: "Not thrilled? We&apos;ll re-detail the area — on us.",
                            },
                        ].map(({ icon: Icon, title, body }) => (
                            <div
                                key={title}
                                className="bg-[#121212] border border-white/5 p-5 hover:border-[#9D4CDD]/30 transition-colors"
                            >
                                <Icon className="text-[#9D4CDD]" size={20} />
                                <div className="mt-3 font-heading text-sm font-semibold text-white">
                                    {title}
                                </div>
                                <div
                                    className="mt-1 text-xs text-white/55 leading-relaxed"
                                    dangerouslySetInnerHTML={{ __html: body }}
                                />
                            </div>
                        ))}
                    </div>

                    <Link
                        to="/about"
                        data-testid="about-learn-more-link"
                        className="mt-10 inline-flex items-center gap-2 font-heading text-[11px] font-bold tracking-[0.28em] uppercase text-[#9D4CDD] hover:text-[#B366F9] transition-colors group"
                    >
                        Read Our Full Story
                        <ArrowRight
                            size={14}
                            className="transition-transform group-hover:translate-x-1"
                        />
                    </Link>
                </div>
            </div>
        </section>
    );
}
